import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import * as _ from 'lodash';
import * as moment from 'moment';
/**Local file */
import { spekwo, checkoutFields } from '../../../../../../utils/index';
import { CommonQueryService } from '../../../../../../queryFiles';
@Injectable()
export class ArchivedOrdersServiceService implements Resolve<any> {

  public archivedOrders: any;
  routeParams: any;
  spekwoValues = spekwo;
  checkoutFields = checkoutFields;
  pageIndexOrders: number = 1;
  allFinalArchivedOrder: any[];

  constructor(public commonQueryService: CommonQueryService,) { }

  /**
   * Resolve
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   * @returns {Observable<any> | Promise<any> | any}
   */
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {

    this.routeParams = route.params;

    return new Promise<void>((resolve, reject) => {

      Promise.all([
      ]).then(
        (res: any) => {
          resolve();
        },
        reject
      );
    });
  }

  getAllArchivedOrders(): Promise<any> {

    return new Promise(async (resolve, reject) => {
      this.commonQueryService.GET_ALL_ARCHIVED_ORDERSLIST().valueChanges.subscribe((archivedRes: any) => {
        let archivedOrders = archivedRes && archivedRes.data && archivedRes.data.allOrders && archivedRes.data.allOrders.nodes.length > 0 ?
          archivedRes.data.allOrders.nodes : [];
        resolve(archivedOrders);
      }, error => {
        resolve([]);
        console.log("error in get archived order form Db ", error);
      });

    });
  }

  getAllArchivedOrdersLimit(payload): Promise<any> {
    return new Promise(async (resolve, reject) => {
      this.commonQueryService.GET_ALL_ARCHIVED_ORDERSLIST_LIMIT(payload).valueChanges.subscribe((archivedRes: any) => {
        let archivedOrders = archivedRes && archivedRes.data && archivedRes.data.allOrders ?
          archivedRes.data.allOrders : {};
        resolve(archivedOrders);
      }, error => {
        resolve({});
        console.log("error in get archived order form Db ", error);
      });
    });
  }

  hoursBasedCost(productCost, discountAmount, paidAmount, createdDate) {
    let dueDate;
    if (productCost == discountAmount + paidAmount) {
      dueDate = moment(new Date(createdDate))
        .add(72, 'hours')
        .format('MM/DD/YYYY');
    }

    else if (productCost + 20 == discountAmount + paidAmount) {
      dueDate = moment(new Date(createdDate))
        .add(48, 'hours')
        .format('MM/DD/YYYY');
    }

    else if (productCost + 40 == discountAmount + paidAmount) {
      dueDate = moment(new Date(createdDate))
        .add(24, 'hours')
        .format('MM/DD/YYYY');
    }
    return dueDate;
  }


  calcDueDate(deliveryTime, createdDate) {
    let dueDate;

    if (deliveryTime.value.includes('72 hours')) {
      dueDate = moment(new Date(createdDate))
        .add(72, 'hours')
        .format('MM/DD/YYYY');
    }

    else if (deliveryTime.value.includes('48 hours')) {
      dueDate = moment(new Date(createdDate))
        .add(48, 'hours')
        .format('MM/DD/YYYY');
    }

    else if (deliveryTime.value.includes('24 hours')) {
      dueDate = moment(new Date(createdDate))
        .add(24, 'hours')
        .format('MM/DD/YYYY');
    }
    return dueDate;
  }

  /**Check orders with fetched data */
  checkDocProcess(orders) {

    return new Promise((resolve, reject) => {
      this.allFinalArchivedOrder = [];
      _.each(orders, (data, key: number) => {
        let orderContentDetails = JSON.parse(data.orderContent);
        var product = orderContentDetails && orderContentDetails.line_items && orderContentDetails.line_items.length > 0 ? this.spekwoValues[orderContentDetails.line_items[0].sku] : '';
        var dueDate;
        var deliveryTime =
          orderContentDetails.line_items && orderContentDetails.line_items.length > 0
            ? _.find(orderContentDetails.line_items[0].meta_data, {
              key: this.checkoutFields.deliveryTime,
            })
            : null;
        if (product == this.spekwoValues.HIQFULL || product == this.spekwoValues.CGPYWCK || product == this.spekwoValues.RJCZPSJ) {
          var check =
            orderContentDetails.line_items && orderContentDetails.line_items.length > 0
              ? _.find(orderContentDetails.line_items[0].meta_data, {
                key: this.checkoutFields.deliveryTime,
              })
              : null;
          let paiAmount = orderContentDetails && orderContentDetails.total ? orderContentDetails.total : 0.00;
          let discount = orderContentDetails && orderContentDetails.coupon_lines.length > 0 && orderContentDetails.coupon_lines[0].discount ? orderContentDetails.coupon_lines[0].discount : 0.00;
          let couponData = data && data.couponByCouponId ? data.couponByCouponId : {};
          let productData = data && data.productByProductId ? data.productByProductId : {};
          if (discount === 0 || discount === 0.00) {
            discount = couponData && couponData.couponAmount ? couponData.couponAmount : 0.00;
          }

          if (!product) {
            product = productData && productData.sku ? productData.sku : "";
          }

          let productAmount = productData && productData.productPrice ? productData.productPrice : 0.00;

          if (product == this.spekwoValues.HIQFULL) {
            dueDate = this.calcDueDate(deliveryTime, orderContentDetails.date_created);
          }
          else if (product == this.spekwoValues.CGPYWCK || product == this.spekwoValues.RJCZPSJ) {
            dueDate = this.calcDueDate(deliveryTime, orderContentDetails.date_created);
          }
        }
        else if ((product == this.spekwoValues.INSPECTIONCALL || product == this.spekwoValues.GCCONSULTING)) {
          var check = _.find(orderContentDetails.meta_data, { key: this.checkoutFields.apptDate });
          dueDate = check ? moment(moment(check.value, 'DD/MM/YYYY').toDate()).format('MM/DD/YYYY') : '';
        }

        var buyerProperty = orderContentDetails ? _.find(orderContentDetails.meta_data, { key: checkoutFields.buyerProperty }) : ''; // Buyer property 
        var agentRole = orderContentDetails ? _.find(orderContentDetails.meta_data, { key: checkoutFields.agentRole }) : ''; // Agent type 
        var propertyRole = orderContentDetails ? _.find(orderContentDetails.meta_data, { key: checkoutFields.propertyRole }) : ''; // Client Name
        var clientName = orderContentDetails ? _.find(orderContentDetails.meta_data, { key: checkoutFields.clientName }) : ''; // Client Name
        var solEmail = orderContentDetails ? _.find(orderContentDetails.meta_data, { key: checkoutFields.solEmail }) : ''; // Solution  email
        var trashOrderStatus = orderContentDetails ? _.findLast(orderContentDetails.meta_data, { key: checkoutFields.trashOrderStatus }) : ''; // Solution  email

        var target = {
          createdAt: data && data.createdAt ? moment(data.createdAt).format('MM/DD/YYYY') : "",
          orderId: data.id,
          dueDate: dueDate ? dueDate : '',
          createdVia: orderContentDetails ? orderContentDetails.created_via : "",
          totalAmount: orderContentDetails ? Number(orderContentDetails.total) : 0.00,
          buyerProperty: buyerProperty ? buyerProperty.value : '', //Buyer property
          productType: product ? product : '',//Product type ,
          agentRole: agentRole ? agentRole.value : '', // Agent type 
          propertyRole: propertyRole ? propertyRole.value : '',
          clientName: clientName ? clientName.value : '',// Client Name
          solEmail: solEmail ? solEmail.value : '',// Solution  email,
          trashOrderStatus: trashOrderStatus ? trashOrderStatus.value : '',
          first_name: orderContentDetails ? orderContentDetails.billing.first_name : '',
          last_name: orderContentDetails ? orderContentDetails.billing.last_name : '',
          city: orderContentDetails ? orderContentDetails.billing.city : '',
          state: orderContentDetails ? orderContentDetails.billing.state : '',
          country: orderContentDetails ? orderContentDetails.billing.country : '',
          postcode: orderContentDetails ? orderContentDetails.billing.postcode : '',
          email: orderContentDetails ? orderContentDetails.billing.email : '',
          phone: orderContentDetails ? orderContentDetails.billing.phone : '',
        }
        data = Object.assign({}, data);
        data = Object.assign({}, data, target);
        key++;
        this.allFinalArchivedOrder.push(data);
        if (orders.length == key + 1) {
          resolve(this.allFinalArchivedOrder);
        }
      })
    })
  }
}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/sidenavs/left/operations/archived-orders-list/archived-orders-service.service.ts